function getHostJSafra() {
  const currentUrl = window.location.href;

  if (
    currentUrl.indexOf("-homol.") !== -1 ||
    currentUrl.indexOf("localhost") !== -1 ||
    currentUrl.indexOf("52.45.235.30") !== -1
  ) {
    return "https://scdcap-h.safra.com.br/asp/FINIdentPos_Frame.asp";
  }
  return "https://wwws.jsafra.com.br/asp/FINIdentPos_Frame.asp";
}

const formExtratoTarifas = {
  form: null,
  formHidden: null,
  hostSafra: getHostJSafra(),

  init() {
    this.form = document.querySelector(".js-form-extrato-tarifas");
    this.formHidden = document.querySelector("form.formHidden");

    if (!this.form || !this.formHidden) {
      console.error("Formulário não encontrado.");
      return;
    }

    this.formInitialize();
  },

  formInitialize() {
    const cpfInput = this.form.querySelector("#cpf");
    const submitBtn = this.form.querySelector("#submit");
    const erroCPF = document.getElementById("erro-CPF");

    // Aplica a máscara de CPF manualmente
    cpfInput.addEventListener("input", () => {
      let cpfValue = cpfInput.value.replace(/\D/g, "");

      // Aplica a máscara conforme digitação
      if (cpfValue.length > 0) {
        cpfValue = cpfValue
          .replace(/^(\d{3})(\d)/, "$1.$2")
          .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
          .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
      }

      cpfInput.value = cpfValue;

      const isValid = cpfValue.replace(/\D/g, "").length === 11;
      submitBtn.disabled = !isValid;
      submitBtn.classList.toggle("btn-habilitado", isValid);

      if (!isValid && cpfValue.replace(/\D/g, "").length > 0) {
        erroCPF.textContent = "CPF incompleto.";
      } else {
        erroCPF.textContent = "";
      }
    });

    // Função para mascarar CPF no log
    function mascararCPF(cpf) {
      return `${cpf.slice(0, 3)}.***.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
    }

    // Submissão do formulário
    this.form.addEventListener("submit", (event) => {
      event.preventDefault();

      const cpfValue = cpfInput.value.trim();
      const cpf = cpfValue.replace(/\D/g, "");

      if (!cpf || cpf.length !== 11) {
        erroCPF.textContent = "CPF inválido ou vazio.";
        return;
      }

      erroCPF.textContent = "";

      const cpfMascarado = mascararCPF(cpf);
      console.log("CPF mascarado:", cpfMascarado);

      this.formHidden.action = this.hostSafra;
      this.formHidden.querySelector("[name='txtCPF']").value = cpf;
      this.formHidden.submit();

      // Reset após submissão
      setTimeout(() => {
        this.form.reset();
        submitBtn.disabled = true;
        submitBtn.classList.remove("btn-habilitado");
        erroCPF.textContent = "";
      }, 2000);
    });
  },
};

// Garante que o DOM esteja carregado antes de iniciar
document.addEventListener("DOMContentLoaded", function () {
  formExtratoTarifas.init();
});